import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="container mx-auto px-4 py-16 max-w-4xl" data-testid="about-page">
        <h1 className="text-4xl font-bold mb-3">About Daily UAE Jobs</h1>
        <p className="text-lg text-[#CE1126] font-semibold mb-10">From CV to Interview, Your Trusted Career Partner.</p>

        <Card className="p-8 space-y-8">
          <p className="text-gray-700 leading-relaxed">
            Daily UAE Jobs is a UAE-focused career support platform and professional community dedicated to helping
            job seekers discover genuine opportunities, improve their professional profiles, and navigate the UAE job
            market with greater confidence.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Our mission goes beyond sharing job vacancies. We aim to build a supportive career community where job
            seekers can access reliable job information, practical guidance, professional development resources, and
            meaningful connections—without unnecessary barriers.
          </p>

          <div>
            <h2 className="text-lg md:text-lg font-bold mb-3">Genuine Job Opportunities. Free Career Guidance.</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We prioritize sharing legitimate, publicly available job opportunities and take reasonable steps to
              verify job information before publication. We actively discourage recruitment scams, misleading
              advertisements, and requests for unauthorized job-seeker payments.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Much of our career guidance is provided free of charge because we believe access to reliable career
              information should not depend on someone's financial situation.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Through our Daily UAE Jobs newsletter and professional community, job seekers can receive job vacancy
              updates, available application details, career guidance, and information about relevant referral
              opportunities.
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-lg font-bold mb-3">Helping Job Seekers Move Forward</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Our community initiatives have supported approximately 1,000 CV assessments, CV improvements, and
              LinkedIn profile optimization activities.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              We have also helped 400+ job seekers secure employment through our community support, guidance,
              connections, and referral efforts, based on our reported outcomes.
            </p>
            <p className="text-gray-700 leading-relaxed">
              These achievements reflect our commitment to practical career support and building a community where
              professionals help one another succeed.
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-lg font-bold mb-3">Career Support Tailored to the UAE Market</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Alongside our free resources, we offer optional professional career services, including:
            </p>
            <ul className="list-disc pl-6 space-y-1.5 text-gray-700">
              <li>ATS CV assessments, CV creation, and optimization</li>
              <li>LinkedIn profile optimization</li>
              <li>Job-specific CV improvement and application support</li>
              <li>Interview preparation and AI-powered career tools</li>
              <li>Personalized career guidance and job-search strategies</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Our goal is to help candidates present their genuine qualifications, skills, and experience more
              effectively—not to invent achievements or promise guaranteed employment.
            </p>
          </div>

          <div>
            <h2 className="text-lg md:text-lg font-bold mb-3">Our Long-Term Vision</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We are working toward a stronger UAE career community where professionals can share genuine
              opportunities, exchange useful information, support one another through appropriate referrals, and help
              more job seekers access employment.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Daily UAE Jobs is not a recruitment agency, does not act as an employer, and does not charge job seekers
              for job referrals or access to shared public vacancies. Employment decisions are made independently by
              hiring employers, and neither referrals nor job placements are guaranteed.
            </p>
          </div>

          <div className="pt-6 border-t">
            <p className="text-[#CE1126] font-semibold">
              Daily UAE Jobs — From CV to Interview, Your Trusted Career Partner.
            </p>
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );
}
